import React from "react";
import {Popconfirm} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import {getCurrentUser} from "../../../../../utils";
import {message} from "../../../utils/sysManagementUtils";

const currentUser = getCurrentUser();
export default class UserTableOperation extends BaseComponent {

    render() {
        const {
            record,
            showResetPwdModal
        } = this.props;
        const currentUser = getCurrentUser();
        const {name, status, id, account, userType} = record;
        return (
            <>
                {
                    userType === "phone" ? null :
                        <span className="cm-link margin-right-15" onClick={() => showResetPwdModal()} style={{color:this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>重置密码</span>
                }
                {
                    currentUser.account !== account ? <>
                     <span className="cm-link margin-right-15"
                           style={{color:this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}
                           onClick={() => this.bpUserByAccount()}>{status === 1 ? "禁用" : "启用"}</span>
                        <Popconfirm
                            title={`确定删除用户：${name}`}
                            onConfirm={() => this.deleteTableItem(id)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <span className="cm-link margin-right-15" style={{color:this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>删除</span>
                        </Popconfirm>
                    </> : null
                }
            </>
        );
    }

    /**
     * 点击删除用户
     * @param id
     */
    deleteTableItem = id => {
        const {updateTable} = this.props;
        this.deleteUserRequest(id, (res) => {
            if (res) {
                message.success("用户删除成功");
                updateTable();
            }
        });
    };

    /**
     * 根据status更改状态
     */
    bpUserByAccount = async () => {
        const {updateTable, record: {id, status}} = this.props;
        if (status === 1) {
            this.disableUserByAccountRequest(id, res => {
                if (res) {
                    message.success("用户已禁用");
                    updateTable();
                }
            });
        } else {
            this.unbanUserRequest(id, res => {
                if (res) {
                    message.success("用户已启用");
                    updateTable();
                }
            });
        }
    };

    /**
     * 删除用户
     * @param id
     * @param callBack
     */
    deleteUserRequest = (id, callBack) => {
        this.request({
            url: "/cm-sites-sys/user/deleteUser",
            method: "post",
            body: {id},
            callBack
        });
    };

    /**
     * 启用用户
     * @param id
     * @param callBack
     */
    unbanUserRequest = (id, callBack) => {
        this.request({
            url: "/cm-sites-sys/user/unbanUser",
            method: "post",
            body: {id},
            callBack
        });
    };

    /**
     * 禁用用户
     * @param id
     * @param callBack
     */
    disableUserByAccountRequest = (id, callBack) => {
        this.request({
            url: "/cm-sites-sys/user/disableUserByAccount",
            method: "post",
            body: {id},
            callBack
        });
    };

}

